.group {
  display: inline-flex;
  gap: var(--space-0-5);
  padding: var(--space-0-5);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-surface-sunken);
}

.segment {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1-5);
  min-width: var(--size-control-sm);
  height: var(--size-control-sm);
  padding: 0 var(--space-2);
  border-radius: var(--radius-sm);
  color: var(--color-fg-muted);
  font-size: var(--text-sm);
  white-space: nowrap;
}

.segment span {
  display: inline-flex;
}

.segment svg {
  width: var(--size-icon);
  height: var(--size-icon);
}

.segment:hover {
  color: var(--color-fg);
}

.segment[data-state="on"] {
  background: var(--color-surface);
  box-shadow: var(--shadow-1);
  color: var(--color-fg);
  font-weight: var(--weight-medium);
}
